// extracted by mini-css-extract-plugin
export default {"drawerBg":"Model_drawerBg__2iIPo","closeBg":"Model_closeBg__gdA7O","drawer":"Model_drawer__txiv8","heading":"Model_heading__FQ7va","cross":"Model_cross__MvlUZ"};